<template>
  <div>
    <v-row class="fill-height">
      <v-col class="py-0">
        <v-sheet height="64">
          <v-toolbar flat color="white">
            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday()"> {{ translate($store.getters.content.today) }} </v-btn>
            <v-btn fab class="mx-2" small color="grey lighten-2" elevation="0" @click="prev()">
              <v-icon small>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn class="mx-2" fab small color="grey lighten-2" elevation="0" @click="next()">
              <v-icon small>mdi-chevron-right</v-icon>
            </v-btn>

            <v-toolbar-title class="ms-2">
              {{ currentMonth }}
            </v-toolbar-title>
          </v-toolbar>
        </v-sheet>
        <v-sheet height="600" class="calendar-wrapper">
          <div class="loader-wrapper" v-if="loading">
            <v-progress-circular indeterminate color="primary"> </v-progress-circular>
          </div>
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="accent"
            :type="type"
            :events="events"
            :event-color="getEventColor"
            :show-month-on-first="false"
            first-interval="7"
            @click:date="dateClick($event)"
            @click:day="dateClick($event)"
            @change="calendarChanged($event)"
            :value="computedDate"
            :locale="languageTag"
          ></v-calendar>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn color="primary" @click="back()" text large>
          <v-icon class="ma-0" left>mdi-chevron-left</v-icon>
          {{ translate($store.getters.content.back) }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
import Shared from '@/helpers/Shared.vue';
import SharedFunctions from '@/mixins/SharedFunctions.vue';

export default {
  props: ['location'],
  mixins: [SharedFunctions],
  data: () => ({
    currentMonth: null,
    focus: '',
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    languageTag: 'en-US',
    locale: 'en',
  }),
  computed: {
    events() {
      return this.$store.state.appointmentsCalendarPage.calendarEvents;
    },
    loading() {
      return this.$store.state.appointmentsCalendarPage.calendarLoader;
    },
    minDate() {
      const now = new Date();
      const date = moment(now).format('YYYY-MM-DD');
      return date;
    },
    maxDate() {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      const maxDate = moment(date).format('YYYY-MM-DD');
      return maxDate;
    },
    computedDate() {
      return this.focus ? moment(this.focus).locale(this.locale).format('DD-MM-YYYY') : '';
    },
    code() {
      return this.$store.state.intakeFormData.code;
    },
  },
  mounted() {},
  methods: {
    dateClick(event) {
      let eventsOnClickedDay = this.events.filter((item) => item.start == event.date);
      //if events set on date
      if (eventsOnClickedDay.length > 0) {
        this.$store.commit('SET_CLICKED_DATE', null);
        this.$router.push({
          name: 'AppointmentsSelectedDayPage',
          params: { selectedDate: event.date, minDate: this.minDate, maxDate: this.maxDate, location: this.location },
        });
      }
      //date before today and empty
      else if (eventsOnClickedDay.length == 0 && this.isBeforeToday(event.date)) {
        // let payload = {
        //   open: true,
        //   text: "Can't create timeslots on a day earlier than today",
        //   color: 'warning'
        // };
        // this.$store.commit('SET_SNACKBAR', payload);
      }
      //day empty, prefill startdate
      else {
        //reset incase person clicks same day
        this.$store.commit('SET_CLICKED_DATE', null);
        setTimeout(() => {
          this.$store.commit('SET_CLICKED_DATE', event.date);
          this.$store.commit('SET_TIME_SLOT_DIALOG', true);
        }, 0);
      }
    },
    setToday() {
      this.focus = '';
    },
    next() {
      this.$refs.calendar.next();
    },
    prev() {
      this.$refs.calendar.prev();
    },
    async calendarChanged(event) {
      this.currentMonth = moment(event.start.month, 'MM').format('MMMM');
      this.$store.commit('SET_CURRENT_CALENDAR_EVENT_RANGE', event);
      this.$parent.$parent.getCalendarEntries();
    },
    getEventColor(event) {
      return event.color;
    },
    isBeforeToday(date) {
      if (moment(date, 'YYYY-MM-DD').isBefore(moment(), 'day')) return true;
      else return false;
    },
    calendarLang() {
      const languageTag = Shared.languageTag();

      if (languageTag != '') {
        this.languageTag = languageTag;
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.calendar-wrapper {
  position: relative;
  .loader-wrapper {
    position: absolute;
    height: 100%;
    width: 100%;
    background: rgba(white, 0.7);
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .v-calendar-weekly__day:hover {
    cursor: pointer;
    background: whitesmoke;
  }
  .v-calendar-weekly__day.v-outside {
    pointer-events: none;
  }
}
.v-toolbar__title {
  text-transform: capitalize;
}
</style>
